import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github.css'; // or any other theme

const ReadmeViewer = ({ task }) => {
  const markdownContent = (task?.readme?.value?.[0] || 'README not available.').replace(/^\s{4}/gm, '') // remove 4 leading spaces
    .replace(/\r\n/g, '\n')
    .trim();
;

  return (
    <div style={{ padding: '1rem', fontFamily: 'Arial, sans-serif', fontSize: '14px',  }}>
      <ReactMarkdown
        children={markdownContent}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          h1: ({ node, ...props }) => <h1 style={{ fontSize: '18px' }} {...props} />,
          h2: ({ node, ...props }) => <h2 style={{ fontSize: '16px' }} {...props} />,
          h3: ({ node, ...props }) => <h3 style={{ fontSize: '14px' }} {...props} />,
          h4: ({ node, ...props }) => <h4 style={{ fontSize: '13px' }} {...props} />,
          h5: ({ node, ...props }) => <h5 style={{ fontSize: '12px' }} {...props} />,
          h6: ({ node, ...props }) => <h6 style={{ fontSize: '11px' }} {...props} />,
          p: ({ node, ...props }) => <p style={{ fontSize: '13px', lineHeight: '1.6' }} {...props} />,
        }}
      />
    </div>
  );
};

export default ReadmeViewer;
